import './styles/catalogFilter.scss';